// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { ExtractProps } from '@Molecules/Details/Details';
import { FormatDate } from '@Molecules/Format';
import { THMarkdown } from '@Molecules/Inputs/THMarkdown/THMarkdown';
import { onOrganisationImageUpload } from '@Helpers/download';
import { THEditable } from '@Molecules/Inputs/THEditable/THEditable';
import { THSelect } from '@Molecules/Inputs/THSelect/THSelect';
import { SharingRuleValues, OrganisationInput } from 'thehive-sdk';
import { OrganisationEventList } from './eventList';

import './extractData.scss';

interface ExtractDataParams {
    locale: (message: string) => string;
    orgId: string;
    eventList: OrganisationEventList;
    hasPermissions?: boolean;
}

export const extractData = ({
    locale,
    orgId,
    eventList,
    hasPermissions,
}: ExtractDataParams): Record<any, ExtractProps> => ({
    _createdAt: {
        name: locale('organisation.layout.left-sider.creation-date'),
        className: 'organisation-details__created-at',
        render: (_createdAt: number): ReactElement => <FormatDate displayFrom={true} date={_createdAt} />,
    },
    description: {
        name: locale('organisation.layout.left-sider.description'),
        className: 'organisation-details__description',
        render: (description: string): ReactElement => (
            <THMarkdown value={description} disabled borderless onImageUpload={onOrganisationImageUpload} />
        ),
    },
    taskRule: {
        render: (taskRule) => (
            <THEditable<Partial<OrganisationInput>>
                name="taskRule"
                label={locale('organisation.create.form.task-rule.label')}
                initialValues={{ taskRule }}
                onFinish={(values) => eventList.onEdit(values, orgId)}
            >
                <THSelect
                    borderless
                    disabled={!hasPermissions}
                    options={SharingRuleValues.map((value) => ({ label: value, value }))}
                    placeholder={locale('organisation.create.form.task-rule.placeholder')}
                />
            </THEditable>
        ),
    },
    observableRule: {
        render: (observableRule) => (
            <THEditable<Partial<OrganisationInput>>
                name="observableRule"
                label={locale('organisation.create.form.observable-rule.label')}
                initialValues={{ observableRule }}
                onFinish={(values) => eventList.onEdit(values, orgId)}
            >
                <THSelect
                    borderless
                    disabled={!hasPermissions}
                    options={SharingRuleValues.map((value) => ({ label: value, value }))}
                    placeholder={locale('organisation.create.form.observable-rule.placeholder')}
                />
            </THEditable>
        ),
    },
});
